// extracted by mini-css-extract-plugin
export default {"advancedTitle":"AdvancedTabTitles__advancedTitle___baLbL","titleLabel":"AdvancedTabTitles__titleLabel___o0btZ"};